import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PrivacyTeam, PrivacyMember } from '@shared/dialogs/private-asset-settings-dialog/privacy.model';
import { TeamContactCardService } from './team-contact-card.service';
import { Observable } from 'rxjs';
import { rouletter } from '@miq/report-export-view';

const COLORS = [
  '#00b2dd',
  '#ec008c',
  '#a23f97',
  '#f58220',
  '#ffdd00',
  '#69be2b',
  '#004b35',
  '#00a657',
  '#bfd857',
  '#00b5db',
  '#d0021b',
];
const palette = rouletter(COLORS);

@Component({
  selector: 'miq-team-contact-card',
  templateUrl: './team-contact-card.component.html',
  styleUrls: ['./team-contact-card.component.scss'],
  providers: [TeamContactCardService],
  standalone: false,
})
export class TeamContactCardComponent {
  @Input()
  public team: PrivacyTeam;
  @Input()
  public selected: boolean;
  @Input()
  public isOnMIQ: boolean;

  @Output()
  public change: EventEmitter<{ checked: boolean; team: PrivacyTeam }> = new EventEmitter();

  public color: string;
  public teamMembers$: Observable<PrivacyMember[]>;

  constructor(private teamContactCardService: TeamContactCardService) {
    this.color = palette.next();
  }

  public getTeamMembers(): void {
    this.teamMembers$ = this.teamContactCardService.getTeamMembers(this.team.id);
  }

  public onClick(event: boolean): void {
    this.change.emit({ checked: event, team: this.team });
  }
}
